export function getDiscountName(name) {
  return name || '[Treatment discount]'
}
